import { z } from 'zod'

export type AttributesCodeBlock = {
  lang: string
}

export const attributesCodeBlockSchema = z.object({
  lang: z.string(),
}) satisfies z.ZodType<AttributesCodeBlock>
